import {Component} from "@angular/core";

@Component({
    selector: 'collapse-form-wrapper',
    template: require('./collapse.form.wrapper.template.html')
})
export class CollapseFormWrapperComponent {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/collapse/collapse.form.wrapper.component.ts